import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseApiWithAuth } from "@/utilities/reduxToolkit";

export const clausesApi = createApi({
  ...createBaseApiWithAuth({
    reducerPath: "clausesApi",
    baseUrl: "/api/clauses",
  }),
  reducerPath: "clausesApi",
  tagTypes: ["Clauses"],
  endpoints: (builder) => ({
    getClauses: builder.query<
      any,
      { search?: string; nextId?: string; limit?: number; scope?: string }
    >({
      query: (args) => {
        const queryParams = new URLSearchParams();
        if (args.search) queryParams.append("query", args.search);
        if (args.limit) queryParams.append("limit", args.limit.toString());
        if (args.nextId) queryParams.append("nextId", args.nextId);
        if (args.scope) queryParams.append("scope", args.scope);
        return `?${queryParams.toString()}`;
      },
      keepUnusedDataFor: 0,
      providesTags: [{ type: "Clauses" }],
    }),
    getClauseById: builder.query<any, { id: string }>({
      query: ({ id }) => `/${id}`,
      providesTags: [{ type: "Clauses" }],
    }),
    createClause: builder.mutation<
      any,
      { name: string; content: any; scope?: string }
    >({
      query: (body) => ({
        url: "",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Clauses" }],
    }),
    updateClause: builder.mutation<
      any,
      { id: string; data: { name?: string; content?: any } }
    >({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [{ type: "Clauses" }],
    }),
    deleteClause: builder.mutation<any, { id: string }>({
      query: ({ id }) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Clauses" }],
    }),
  }),
});

export const {
  useGetClausesQuery,
  useGetClauseByIdQuery,
  useCreateClauseMutation,
  useUpdateClauseMutation,
  useDeleteClauseMutation,
} = clausesApi;
